var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gauge-widget"},[_c('k-gauge',_vm._b({attrs:{"title":''}},'k-gauge',_vm.opts,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }